import { render } from "./main-layout.vue?vue&type=template&id=b3e68fdc&ts=true"
import script from "./main-layout.vue?vue&type=script&lang=ts"
export * from "./main-layout.vue?vue&type=script&lang=ts"

import "./main-layout.vue?vue&type=style&index=0&id=b3e68fdc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__